import globalFilterTypes from "reduxStore/globalFilter/globalFilter.types";

export const getActivePermissions = ({ activeSectionItem, activeMenuItem, activeTopNavItem }) => {
  return (
    activeSectionItem?.permissions ?? activeMenuItem.permissions ?? activeTopNavItem.permissions
  );
};

export const createNavItem = (params) => {
  if (params.permissions) {
    // default is allowed
    params.requireClientSelection = params.requireClientSelection || true; // default is true
    if (params.requireClientSelection && !params.clientInfo.clientID) return null;

    const isPermitted = params.IsMenuItemAuthorized(params);
    if (!isPermitted) {
      return null;
    }
  }

  if (params.items && !params.items.some((i) => i !== null)) {
    //if no child item is authorized return null
    return null;
  }
  const { label, path } = params;
  return {
    id: label + path, //+ r,
    ...params,
  };
};

export const checkFilterResetRule = (dispatch, filters) => {
  const paths_from_reset_filters = [
    "/performance/blocking_details",
    "/performance/deadlocks_details",
    "/performance/jobs_details",
    "/performance/index_details",
    "/compliance/event_details",
    "/compliance/security_details",
    "/performance/connections_details",
    "/health/alerts_details",
  ];

  const path = window.location.pathname;
  let globalFilters = {
    servername: filters?.servername || [],
    databasename: [],
    blockerid: [],
    deadlockgroupid: [],
    connectionHost: [],
    resourceName: [],
  };

  if (paths_from_reset_filters.includes(path)) {
    dispatch({
      type: globalFilterTypes.UPDATE_TOP_FILTER,
      payload: globalFilters,
    });
  }
};
